import { createShader, colorUniform } from "./ShaderBase.js";

export const forestShader = createShader({
  customizable: [
    { uniform: "uColorDark", label: "Dark", default: "#050f05" },
    { uniform: "uColorMid", label: "Mid", default: "#0f2610" },
  ],

  uniforms: {
    uPixelSize: { value: 12.0 },
    uScale: { value: 0.8 },
    uSpeed: { value: 0.12 },
    uColorDark: colorUniform("#050f05"),
    uColorMid: colorUniform("#0f2610"),
    uColorLight: colorUniform("#1a3a1a"),
    uColorBright: colorUniform("#2d4a2d"),
  },

  fragmentUniforms: `
    uniform vec3 uColorDark;
    uniform vec3 uColorMid;
    uniform vec3 uColorLight;
    uniform vec3 uColorBright;
  `,

  fragmentBody: `
    // Wave pattern - creates bands/stripes
    float waveFreq = 0.3;
    float wave = sin(
      pixelatedPos.x * waveFreq +
      pixelatedPos.y * waveFreq * 0.7 +
      pixelatedPos.z * waveFreq * 0.5 +
      uTime * uSpeed
    );

    // Modulate wave with noise to make it organic/wobbly
    float noiseOffset = snoise(pixelatedPos * 0.15 + vec3(uTime * uSpeed * 0.2));
    wave += noiseOffset * 0.8;

    // Normalize to 0-1
    wave = wave * 0.5 + 0.5;
    wave = clamp(wave, 0.0, 1.0);

    // Quantize to 4 distinct color bands - hard edges (constant interpolation)
    vec3 color = uColorDark;
    color = wave > 0.25 ? uColorMid : color;
    color = wave > 0.5 ? uColorLight : color;
    color = wave > 0.75 ? uColorBright : color;

    gl_FragColor = vec4(color, 1.0);
  `,
});
